import { render } from "./avatar7.vue?vue&type=template&id=77f327c4"
const script = {}

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__